import { Icon, SvgBack5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch, useSelector } from 'react-redux';

import { ROLLOUT_WEAVE, VARIANT } from 'constants/featureFlag';
import { PLAYER_LONG_STEP } from 'constants/videoPlayer';
import { skipBack, skipBackEditMode } from 'creators/videoPlayer';
import { selectInTrimMode } from 'selectors/shareVideo';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import ControlBarButton from '../control-bar-button';

import { useClipsState } from 'components/share-video/edit-tools/clips/state';

import './styles.less';

export default function StepBackFiveButton(props) {
  const dispatch = useDispatch();

  const inTrimMode = useSelector(selectInTrimMode);

  const weaveFlagValue = useFeatureFlagValue(ROLLOUT_WEAVE);
  const rolloutWeave = VARIANT.includes(weaveFlagValue);

  const clipsState = useClipsState(state => ({
    clips: state.clips,
    focusedClipIndex: state.focusedClipIndex,
    updateFocusedClipIndex: state.updateFocusedClipIndex,
    updateFocusedPlayRangeIndex: state.updateFocusedPlayRangeIndex,
  }));

  const stepBack = () => {
    if (inTrimMode && rolloutWeave) {
      dispatch(skipBackEditMode(PLAYER_LONG_STEP, clipsState));
    } else {
      dispatch(skipBack());
    }
  };

  useHotkeys('j, left', stepBack, [inTrimMode, clipsState]);

  return (
    <ControlBarButton
      className={classNames('step-back-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Back (j)"
      seeking={props.seeking}
      onClick={stepBack}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgBack5 />}
      />
    </ControlBarButton>
  );
}
